import { Box, Typography } from '@mui/material';
import elevenLogo from '../../../assets/games/ElevenLogo.png';

function SplashScreen() {
  return (
    <Box
      sx={{
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
        background: '#0a0b12',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'radial-gradient(ellipse 80% 50% at 50% -10%, rgba(239, 68, 68, 0.24), transparent 55%), radial-gradient(ellipse 60% 40% at 100% 30%, rgba(99, 102, 241, 0.14), transparent 50%), radial-gradient(ellipse 50% 35% at 0% 70%, rgba(16, 185, 129, 0.08), transparent 45%)',
          pointerEvents: 'none',
        }}
      />
      <Box
        component="img"
        src={elevenLogo}
        alt="Eleven Games"
        sx={{
          width: 'min(72vw, 220px)',
          height: 'auto',
          zIndex: 1,
          objectFit: 'contain',
        }}
      />
      <Typography sx={{ opacity: 0.88, color: 'rgba(255,255,255,0.75)', zIndex: 1 }}>
        Ready. Set. Win.
      </Typography>
    </Box>
  );
}

export default SplashScreen;
